import { useFormatters } from '@/shared/hooks/useFormatters/useFormatters.ts';
import { SummaryItem } from './SummaryItem.tsx';
import { useTranslation } from 'react-i18next';
import { getTagType } from '@/shared/utils/getTagType.ts';
import { BalanceSheetMap } from '@/shared/hooks/useBalanceSheet.ts';

type SummaryItemsProps = {
    balanceSheetMap: BalanceSheetMap;
};

export function SummaryItems({ balanceSheetMap }: SummaryItemsProps) {
    const { formatNumberWithCurrency, formatPercentage } = useFormatters();
    const { t } = useTranslation();

    const orderStats = balanceSheetMap.get('ORDER');
    const fulfillmentStats = balanceSheetMap.get('FULFILLMENT');

    const oldStats = fulfillmentStats && orderStats;
    const currentStats = fulfillmentStats || orderStats;
    if (!currentStats) {
        return null;
    }

    return (
        <div className="border-t-active flex justify-end divide-x border-t px-2 py-6">
            <SummaryItem
                label={t('sections.summary.balancesheet.totalrevenue')}
                beforeValue={oldStats && formatNumberWithCurrency(oldStats.revenue)}
                value={formatNumberWithCurrency(currentStats.revenue)}
                type={getTagType({ value: currentStats.revenue })}
                className="pl-0"
            />
            <SummaryItem
                label={t('sections.summary.balancesheet.totalcosts')}
                beforeValue={oldStats && formatNumberWithCurrency(oldStats.costs)}
                value={formatNumberWithCurrency(currentStats.costs)}
                type={getTagType({ value: currentStats.costs, reverseFlag: true })}
            />
            <SummaryItem
                label={t('sections.summary.balancesheet.totalprofit')}
                beforeValue={oldStats && formatNumberWithCurrency(oldStats.profit)}
                value={formatNumberWithCurrency(currentStats.profit)}
                type={getTagType({ value: currentStats.profit })}
            />
            <SummaryItem
                label={t('sections.summary.balancesheet.takerate')}
                beforeValue={oldStats && formatPercentage(oldStats.takeRate)}
                value={formatPercentage(currentStats.takeRate)}
                type={getTagType({ value: currentStats.takeRate })}
                className="pr-0"
            />
        </div>
    );
}
